import React from 'react';
import { AircraftPart } from '../types/aircraft';
import './CreateRequestModal.css';

interface AircraftSchemaProps {
  aircraftView: 'top' | 'front';
  selectedAircraftParts: string[]; // Изменено на массив
  hoveredPart: string;
  onPartSelect: (partId: string) => void;
  onPartHover: (partId: string) => void;
  onPartLeave: () => void;
  aircraftParts: AircraftPart[];
  onViewChange?: (view: 'top' | 'front') => void;
}

const AircraftSchema: React.FC<AircraftSchemaProps> = ({
  aircraftView,
  selectedAircraftParts,
  hoveredPart,
  onPartSelect,
  onPartHover,
  onPartLeave,
  aircraftParts,
  onViewChange
}) => {
  return (
    <div className="aircraft-schema">
      <h4>Схема самолета</h4>
      
      {/* Переключатель вида */}
      <div className="view-toggle">
        <button
          type="button"
          className={`view-button ${aircraftView === 'top' ? 'active' : ''}`}
          onClick={() => onViewChange?.('top')}
        >
          Вид сверху
        </button>
        <button
          type="button"
          className={`view-button ${aircraftView === 'front' ? 'active' : ''}`}
          onClick={() => onViewChange?.('front')}
        >
          Вид спереди
        </button>
      </div>

      <div className="aircraft-diagram">
        {aircraftView === 'top' ? (
          // Вид сверху
          <svg width="1055" height="777" viewBox="0 0 1055 777" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Фюзеляж (было правое крыло) */}
            <path 
              d="M874.446 344.128L915.108 349.01L949.005 355.847V355.846L970.808 360.406L970.811 360.407L991.629 364.637V364.638L1016.8 370.818L1035.66 376.996L1046.26 381.854L1051.48 385.364L1053.49 388.15L1054.22 390.822L1052.88 393.805L1050.09 395.996L1046.26 398.572L1037.11 403.103L1020.2 408.625L1001.8 413.182L983.879 417.415L953.37 423.274L919.946 429.136L898.157 432.716L874.447 435.318H622.5V342.503L874.446 344.128Z" 
              fill={
                selectedAircraftParts.includes('fuselage') ? '#ef4444' : 
                hoveredPart === 'fuselage' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('fuselage') || hoveredPart === 'fuselage' ? "2" : "1"}
              onClick={() => onPartSelect('fuselage')}
              onMouseEnter={() => onPartHover('fuselage')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левое крыло */}
            <path 
              d="M451.182 264.435L451.155 264.357L362.633 0.96582L364.02 0.5H369.266L376.007 0.823242L378.41 1.14746L378.421 1.14844L381.312 1.47266L389.457 3.08301L396.895 6.79199L403.866 10.8311L408.625 14.9912L416.332 26.9717V26.9727L429.406 48.4561H429.407L454.121 92.7598L454.131 92.7754L507.437 180.404L552.5 257.277L552.509 257.292L552.52 257.307L581.11 299.004L595.154 321.141L595.2 321.215L595.27 321.269L619.315 339.919H451.182V264.435Z" 
              fill={
                selectedAircraftParts.includes('left-wing') ? '#ef4444' : 
                hoveredPart === 'left-wing' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('left-wing') || hoveredPart === 'left-wing' ? "2" : "1"}
              onClick={() => onPartSelect('left-wing')}
              onMouseEnter={() => onPartHover('left-wing')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правый борт (был левый борт) */}
            <path 
              d="M620.543 388.5V435.712L234.362 435.095L207.255 432.934L184.974 429.845H184.973L146.711 423.357L139.463 421.816L130.751 419.656L130.742 419.654L130.734 419.652L119.541 417.272L122.361 388.5H620.543Z" 
              fill={
                selectedAircraftParts.includes('right-side') ? '#ef4444' : 
                hoveredPart === 'right-side' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('right-side') || hoveredPart === 'right-side' ? "2" : "1"}
              onClick={() => onPartSelect('right-side')}
              onMouseEnter={() => onPartHover('right-side')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левый борт (был правый борт) */}
            <path 
              d="M621.059 386.409V341.802L234.862 340.501L222.292 341.476H222.293L207.276 342.779L185.009 346.032L166.605 348.962H166.606L147.724 352.217H147.725L139.971 353.846L130.781 356.122H130.78L120.533 358.628L122.882 386.409H621.059Z" 
              fill={
                selectedAircraftParts.includes('left-side') ? '#ef4444' : 
                hoveredPart === 'left-side' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('left-side') || hoveredPart === 'left-side' ? "2" : "1"}
              onClick={() => onPartSelect('left-side')}
              onMouseEnter={() => onPartHover('left-side')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правое крыло (был фюзеляж) */}
            <path 
              d="M451.182 511.984L451.155 512.061L362.633 775.453L364.02 775.919H369.266L376.007 775.595L378.41 775.271L378.421 775.27L381.312 774.946L389.457 773.336L396.895 769.627L403.866 765.588L408.625 761.427L416.332 749.447V749.446L429.406 727.963H429.407L454.121 683.659L454.131 683.643L507.437 596.014L552.5 519.141L552.509 519.127L552.52 519.112L581.11 477.415L595.154 455.278L595.2 455.204L595.27 455.15L619.315 436.5H451.182V511.984Z" 
              fill={
                selectedAircraftParts.includes('right-wing') ? '#ef4444' : 
                hoveredPart === 'right-wing' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('right-wing') || hoveredPart === 'right-wing' ? "2" : "1"}
              onClick={() => onPartSelect('right-wing')}
              onMouseEnter={() => onPartHover('right-wing')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левый хвост */}
            <path 
              d="M46.5361 374.248L46.5156 374.177L1.15625 222.365H18.166L47.5762 261.257L87.3076 315.977L87.3096 315.98L119.206 359.189L121.097 385.874H26.9736L28.0156 383.771L32.2246 380.627L39.8867 377.729L46.1621 376.107L46.5361 376.01V374.248Z" 
              fill={
                selectedAircraftParts.includes('left-tail') ? '#ef4444' : 
                hoveredPart === 'left-tail' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('left-tail') || hoveredPart === 'left-tail' ? "2" : "1"}
              onClick={() => onPartSelect('left-tail')}
              onMouseEnter={() => onPartHover('left-tail')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правый хвост */}
            <path 
              d="M46.0518 399.476L46.0312 399.547L0.671875 551.359H17.6816L47.0918 512.467L86.8232 457.747L86.8252 457.744L118.728 414.527L121.564 386.874H26.8076L27.5801 389.989L31.7402 393.096L39.4023 395.995L45.6777 397.617L46.0518 397.714V399.476Z" 
              fill={
                selectedAircraftParts.includes('right-tail') ? '#ef4444' : 
                hoveredPart === 'right-tail' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('right-tail') || hoveredPart === 'right-tail' ? "2" : "1"}
              onClick={() => onPartSelect('right-tail')}
              onMouseEnter={() => onPartHover('right-tail')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
          </svg>
        ) : (
          // Вид спереди
          <svg width="1757" height="747" viewBox="0 0 1757 747" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Левое крыло (вид спереди) */}
            <path 
              d="M308.802 456.489C282.74 451.299 286.509 412.931 313.084 412.913L861.611 412.554C874.617 412.545 884.791 423.762 883.519 436.706L872.957 544.193C871.685 557.137 859.522 566.158 846.766 563.618L308.802 456.489Z" 
              fill={
                selectedAircraftParts.includes('front-left-wing') ? '#ef4444' : 
                hoveredPart === 'front-left-wing' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-left-wing') || hoveredPart === 'front-left-wing' ? "2" : "1"}
              onClick={() => onPartSelect('front-left-wing')}
              onMouseEnter={() => onPartHover('front-left-wing')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правое крыло (вид спереди) */}
            <path 
              d="M1428.46 410.026C1455.16 409.956 1458.89 448.582 1432.67 453.629L909.721 554.297C896.991 556.747 884.913 547.714 883.665 534.811L874.066 435.536C872.818 422.633 882.942 411.453 895.906 411.419L1428.46 410.026Z" 
              fill={
                selectedAircraftParts.includes('front-right-wing') ? '#ef4444' : 
                hoveredPart === 'front-right-wing' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-right-wing') || hoveredPart === 'front-right-wing' ? "2" : "1"}
              onClick={() => onPartSelect('front-right-wing')}
              onMouseEnter={() => onPartHover('front-right-wing')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Хвост (вид спереди) */}
            <path 
              d="M868.623 18.5732C870.349 4.52449 890.717 4.52423 892.443 18.5732L921.798 257.537C922.677 264.691 917.095 271 909.888 271H851.179C843.971 271 838.39 264.691 839.269 257.537L868.623 18.5732Z" 
              fill={
                selectedAircraftParts.includes('front-tail') ? '#ef4444' : 
                hoveredPart === 'front-tail' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-tail') || hoveredPart === 'front-tail' ? "2" : "1"}
              onClick={() => onPartSelect('front-tail')}
              onMouseEnter={() => onPartHover('front-tail')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левый двигатель */}
            <circle 
              cx="534.533" 
              cy="560" 
              r="52" 
              fill={
                selectedAircraftParts.includes('front-left-engine') ? '#ef4444' : 
                hoveredPart === 'front-left-engine' ? '#fecaca' : 'white'
              }
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-left-engine') || hoveredPart === 'front-left-engine' ? "2" : "1"}
              onClick={() => onPartSelect('front-left-engine')}
              onMouseEnter={() => onPartHover('front-left-engine')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правый двигатель */}
            <circle 
              cx="1188.54" 
              cy="560" 
              r="52" 
              fill={
                selectedAircraftParts.includes('front-right-engine') ? '#ef4444' : 
                hoveredPart === 'front-right-engine' ? '#fecaca' : 'white'
              }
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-right-engine') || hoveredPart === 'front-right-engine' ? "2" : "1"}
              onClick={() => onPartSelect('front-right-engine')}
              onMouseEnter={() => onPartHover('front-right-engine')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Фюзеляж (вид спереди) */}
            <path 
              d="M874.033 244C970.939 244 1049.53 322.777 1049.53 420C1049.53 517.223 970.939 596 874.033 596C777.128 596 698.533 517.223 698.533 420C698.533 322.777 777.128 244 874.033 244Z" 
              fill={
                selectedAircraftParts.includes('front-fuselage') ? '#ef4444' : 
                hoveredPart === 'front-fuselage' ? '#fecaca' : 'white'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-fuselage') || hoveredPart === 'front-fuselage' ? "2" : "1"}
              onClick={() => onPartSelect('front-fuselage')}
              onMouseEnter={() => onPartHover('front-fuselage')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Шасси (центральная стойка) */}
            <path 
              d="M873.533 588V696" 
              stroke={
                selectedAircraftParts.includes('front-landing-gear') ? '#ef4444' : 'black'
              }
              strokeWidth={selectedAircraftParts.includes('front-landing-gear') || hoveredPart === 'front-landing-gear' ? "4" : "2"}
              onClick={() => onPartSelect('front-landing-gear')}
              onMouseEnter={() => onPartHover('front-landing-gear')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'stroke 0.2s ease' }}
            />
            
            {/* Левая стойка шасси */}
            <rect 
              x="821.533" 
              y="656" 
              width="37" 
              height="83" 
              rx="12" 
              fill={
                selectedAircraftParts.includes('front-left-landing-gear') ? '#ef4444' : 
                hoveredPart === 'front-left-landing-gear' ? '#fecaca' : 'white'
              }
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-left-landing-gear') || hoveredPart === 'front-left-landing-gear' ? "2" : "1"}
              onClick={() => onPartSelect('front-left-landing-gear')}
              onMouseEnter={() => onPartHover('front-left-landing-gear')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правая стойка шасси */}
            <rect 
              x="888.533" 
              y="656" 
              width="37" 
              height="83" 
              rx="12" 
              fill={
                selectedAircraftParts.includes('front-right-landing-gear') ? '#ef4444' : 
                hoveredPart === 'front-right-landing-gear' ? '#fecaca' : 'white'
              }
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-right-landing-gear') || hoveredPart === 'front-right-landing-gear' ? "2" : "1"}
              onClick={() => onPartSelect('front-right-landing-gear')}
              onMouseEnter={() => onPartHover('front-right-landing-gear')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левый борт (вид спереди) */}
            <path 
              d="M703.533 420H873.533V588H845.895L814.607 576.5L788.533 564.5L762.981 544L738.993 523L720.22 492L708.226 460L703.533 420Z" 
              fill={
                selectedAircraftParts.includes('front-left-side') ? '#ef4444' : 
                hoveredPart === 'front-left-side' ? '#fecaca' : '#D9D9D9'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-left-side') || hoveredPart === 'front-left-side' ? "2" : "1"}
              onClick={() => onPartSelect('front-left-side')}
              onMouseEnter={() => onPartHover('front-left-side')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Правый борт (вид спереди) */}
            <path 
              d="M1044.53 420H873.533V588H901.334L935.016 581L964.797 569.5L986.412 548.5L1008.86 523L1027.75 492L1039.81 460L1044.53 420Z" 
              fill={
                selectedAircraftParts.includes('front-right-side') ? '#ef4444' : 
                hoveredPart === 'front-right-side' ? '#fecaca' : '#D9D9D9'
              } 
              stroke="black"
              strokeWidth={selectedAircraftParts.includes('front-right-side') || hoveredPart === 'front-right-side' ? "2" : "1"}
              onClick={() => onPartSelect('front-right-side')}
              onMouseEnter={() => onPartHover('front-right-side')}
              onMouseLeave={onPartLeave}
              style={{ cursor: 'pointer', transition: 'fill 0.2s ease' }}
            />
            
            {/* Левая дверь (только для вида) */}
            <path 
              d="M794.437 331.207L853.755 332.305C860.295 332.426 865.533 337.762 865.533 344.303V377C865.533 383.627 860.161 389 853.533 389H772.844C763.39 389 757.649 378.577 762.701 370.587L784.071 336.791C786.313 333.246 790.243 331.129 794.437 331.207Z" 
              stroke="black"
              strokeWidth="2"
              fill="none"
              style={{ pointerEvents: 'none' }}
            />
            
            {/* Правая дверь (только для вида) */}
            <path 
              d="M893.802 387.779C887.149 387.815 881.737 382.432 881.737 375.779V343.556C881.737 336.929 887.11 331.556 893.737 331.556H959.311C963.654 331.556 967.659 333.903 969.781 337.693L987.574 369.466C992.04 377.439 986.308 387.279 977.169 387.329L893.802 387.779Z" 
              stroke="black"
              strokeWidth="2"
              fill="none"
              style={{ pointerEvents: 'none' }}
            />
          </svg>
        )}
      </div>
      
      {/* Индикатор выбранной части */}
      {selectedAircraftParts.length > 0 && (
        <div className="selected-part-indicator">
          <span>Выбраны части: <strong>{selectedAircraftParts.map(id => aircraftParts.find(p => p.id === id)?.name).filter(name => name).join(', ')}</strong></span>
        </div>
      )}
    </div>
  );
};

export default AircraftSchema; 